import { render } from "./index.vue?vue&type=template&id=6b2eb226&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=6b2eb226&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=6b2eb226&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2eb226"]])

export default __exports__